import styled from 'styled-components'

export const StyledEditor = styled.div`
  .ck-editor__top {
    height: 0 !important;
  }

  .ck-content {
    border: none !important;
    padding: 0 !important;
    overflow-x: auto;
    --ck-content-font-family: Inter, 'Noto Sans JP', 'Noto Sans KR',
      'Noto Sans SC', 'Noto Sans TC', sans-serif;
    --ck-content-font-size: 14px;
    --ck-content-word-break: break-word;
    --ck-content-overflow-wrap: break-word;
    --ck-content-line-height: 1.4;

    p {
      margin: 0;
    }

    img {
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }

    .image-style-align-left {
      float: left;
      margin-right: 1.5em;
    }

    .image-style-align-right {
      float: right;
      margin-left: 1.5em;
    }

    .image-style-side {
      float: right;
      margin-left: 1.5em;
      max-width: 50%;
    }

    .image-style-block-align-left {
      margin-left: 0;
      margin-right: auto;
    }

    .image-style-block-align-right {
      margin-left: auto;
      margin-right: 0;
    }

    figure.image {
      display: table;
      clear: both;
      margin: 0 auto;

      &.image-style-align-left,
      &.image-style-align-right,
      &.image-style-side {
        clear: none;
      }

      &.image-style-align-left {
        margin: 0 1.5em 0 0;
      }

      &.image-style-align-right,
      &.image-style-side {
        margin: 0 0 0 1.5em;
      }

      &.image-style-block-align-left {
        margin-left: 0;
        margin-right: auto;
      }

      &.image-style-block-align-right {
        margin-left: auto;
        margin-right: 0;
      }
    }

    img.image-style-align-left,
    img.image-style-align-right,
    img.image-style-side {
      margin-left: 0;
      margin-right: 0;
    }

    img.image-style-align-left {
      margin-right: 1.5em;
    }

    img.image-style-align-right,
    img.image-style-side {
      margin-left: 1.5em;
    }

    figure.table {
      display: table;
      margin-top: 0.9em;
      margin-bottom: 0.9em;
    }

    figure.table table,
    table {
      width: 100%;
      border: 1px double #b3b3b3;
      border-collapse: collapse;
      border-spacing: 0;

      th {
        text-align: left;
      }

      & > thead,
      & > tbody {
        & > tr > td,
        & > tr > th {
          border: 1px solid #bfbfbf;
          min-width: 2em;
          padding: 0.4em;
        }

        & > tr > th {
          background: rgba(0, 0, 0, 0.05);
          font-weight: 700;
        }
      }
    }
  }
`
